import { IBeneficiary } from '@/features/beneficiaries/store/models/beneficiary.model';

export const BeneficiaryTools = {
  excludeBlacklistUmr: (beneficiary?: IBeneficiary): IBeneficiary | undefined => {
    if (!beneficiary) return;

    const sddCoreKnownUniqueMandateReference = beneficiary.sddCoreKnownUniqueMandateReference?.filter((umr: string) => {
      const sddCoreBlacklist = beneficiary.sddCoreBlacklist?.map((blacklistUmr) => blacklistUmr.toUpperCase());
      return !sddCoreBlacklist?.includes(umr.toUpperCase());
    });

    return { ...beneficiary, sddCoreKnownUniqueMandateReference };
  },
};
